import { Flex } from 'component/base/Grid';
import styled from 'styled-components';

import {
  IContentContainerStyleProps,
  IContentInnerWidthStyleProps,
  MarginLeft,
  Padding,
  Width,
} from './types';

const paddingTypes = {
  [Padding.LARGE]: '24px 40px 24px',
  [Padding.SMALL]: '0 20px',
};

export const ContentContainer = styled(Flex)<IContentContainerStyleProps>`
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.colors.offWhite};
  margin-top: ${({ theme }) => theme.layout.topHeader.height};
  margin-left: ${({ marginLeftType, theme }) =>
    marginLeftType === MarginLeft.LEFT_NAV
      ? `calc(${theme.layout.leftNav.width} + 1rem)`
      : '0px'};
  margin: ${({ containerMargin }) => containerMargin};
  padding: ${({ paddingType }) => paddingTypes[paddingType]};
  width: ${({ containerWidth }) => containerWidth || '100%'};
`;

ContentContainer.defaultProps = {
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  p: 4,
};

const widthTypes = {
  [Width.FULL]: '100%',
  [Width.SMALL]: '1190px',
  [Width.MEDIUM]: '1280px',
};

export const ContentWidth = styled(Flex)<IContentInnerWidthStyleProps>`
  max-width: ${({ widthType }) => widthTypes[widthType]};
  width: 100%;
`;

ContentWidth.defaultProps = {
  flex: 1,
  flexDirection: 'column',
};
